import { useEffect, useRef, useState } from 'react'
import { SegCoberturaInfo } from '../../../SegCoberturaInfo/SegCoberturaInfo'
import { SegFormEmisionContainer } from '../../../SegFormEmisionContainer/SegFormEmisionContainer'
import { SegInput } from '../../../SegUI/SegInput/SegInput'
import { SegButton } from '../../../SegUI/SegButton/SegButton'
import { Controller, FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { IEmisionValues, IVencimiento, useEmisionStore } from '../../../../Services/Providers/EmisionStore'
import Cards, { Focused } from 'react-credit-cards-argentina';
import "react-credit-cards-argentina/dist/es/styles-compiled.css"
import { SegSelect, SegSelectOption } from '../../../SegUI/SegSelect/SegSelect'
import obtenerBancos from '../../../../Services/API/Bancos'
import obtenerTiposTarjeta from '../../../../Services/API/TiposTarjeta'
import { Link } from 'react-router-dom'
import styled from '@emotion/styled'
import { useCotizacionStore } from '../../../../Services/Providers/CotizacionStore'
import cabal from "../../../../Assets/img/cabal_logo.png"
import generico from "../../../../Assets/img/generico_logo.jpg"
import { ModalTerminosYCondiciones } from '../../Auto/Emision/ModalTerminosYCondiciones'
import emisionAP, { DataEmisionAP } from '../../../../Services/API/EmisionAP'

const StyledLink = styled(Link)`
    padding: 10px;
    padding-left:25px;
    padding-right:25px;
    width: 100%;
    color: #2C7DFD;
    background-color: #ffffff;
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    -webkit-user-select: none;
    user-select: none;
    border: 0;
    border-radius: 5px;
`



interface IDatosTarjeta {
    numeroTarjeta: string;
    titularTarjeta: string;
    banco: string;
    tipo: string;
    vencimiento: IVencimiento;
    cvc: string;
}

interface StyledCardWrapperProps {
    cardType: CardType;
}

const StyledCardWrapper = styled.div<StyledCardWrapperProps>`
  /*.rccs__card--maestro .rccs__card__background{
    background: ${props =>
        props.cardType === 'cabal' ? 'linear-gradient(25deg, #0f509e, #1399cd)' : ''};
                    
  }*/
  .rccs__card--maestro .rccs__issuer{
    background-image: ${props =>
        props.cardType === 'cabal' ? `url(${cabal})` : `url(${generico})`
    }}
`;

type CardType = 'cabal' | 'default';


type TipoTarjeta = "AMERICAN EXPRESS" | "ARGENCARD" | "CABAL" |
    "CMR" | "CREDIMAS" | "DINERS" |
    "MASTERCARD" | "NEVADA" | "PROVENCRED" |
    "TARJETA MAS" | "TARJETA NARANJA" | "VISA" |
    "DESCONOCIDO";

const TIPOS_TARJETAS: TipoTarjeta[] = [
    "AMERICAN EXPRESS", "ARGENCARD", "CABAL",
    "CMR", "CREDIMAS", "DINERS",
    "MASTERCARD", "NEVADA", "PROVENCRED",
    "TARJETA MAS", "TARJETA NARANJA", "VISA",
    "DESCONOCIDO"
]
interface Props {
    emisionValues: IEmisionValues;
}

export const DatosTarjeta = ({ emisionValues }: Props) => {
    const nav = useNavigate();

    const { setEmisionValues } = useEmisionStore();
    const { cotizacionValues } = useCotizacionStore();

    const [numeroTarjeta, setNumeroTarjeta] = useState<string>("")
    const [mes, setMes] = useState<string>("")
    const [anio, setAnio] = useState<string>("")

    const [bancos, setBancos] = useState<SegSelectOption[]>([])
    const [bancoSelected, setBancoSelected] = useState<SegSelectOption>()
    const [bancosLoading, setBancosLoading] = useState<boolean>()

    const [tipos, setTipos] = useState<SegSelectOption[]>([])
    const [tiposFiltrados, setTiposFiltrados] = useState<SegSelectOption[]>([])
    const [tipoSelected, setTipoSelected] = useState<SegSelectOption>()
    const [tiposLoading, setTiposLoading] = useState<boolean>()


    const [titularTarjeta, setTitularTarjeta] = useState<string>("")
    const [focused, setFocused] = useState<Focused>("number")
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const [enviando, setEnviando] = useState<boolean>(false);

    const [errorMes, setErrorMes] = useState<boolean>(false)
    const [ingreseMes, setIngreseMes] = useState<boolean>(false);
    const [errorVencimiento, setErrorVencimiento] = useState<boolean>(false)
    const [errorAnio, setErrorAnio] = useState<boolean>(false)
    const [ingreseAnio, setIngreseAnio] = useState<boolean>(false);
    const { handleSubmit, control, setValue, formState, trigger, getValues } = useForm<IDatosTarjeta>();
    const [hayError, setHayError] = useState<boolean>(false);

    const methods = useForm();
    const anioRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        const numeroTarjetaInput = document.getElementById("numeroTarjeta");
        if (numeroTarjetaInput && numeroTarjetaInput.tagName.toLowerCase() === "input") {
            numeroTarjetaInput.focus();
        }
    }, []);

    useEffect(() => {
        setBancosLoading(true);
        const fetchBancos = async () => {
            const response: any = await obtenerBancos();
            const formattedData: SegSelectOption[] = response.map((item: any, index: any) => ({
                value: item.codigo,
                label: item.descripcion,
            }));
            setBancos(formattedData);
        };

        fetchBancos().then(() => {
            setBancosLoading(false);
            if (emisionValues?.banco) {
                setBancoSelected(emisionValues.banco)
            }
        });

        setTiposLoading(true);
        const fetchTiposTarjeta = async () => {
            const response: any = await obtenerTiposTarjeta(emisionValues.cotizacionDescAP?.CodigoCompania ? emisionValues.cotizacionDescAP.CodigoCompania : "");
            //const response: any = await obtenerTiposTarjeta("Experta");
            const formattedData: SegSelectOption[] = response.map((item: any, index: any) => ({
                value: item.codigo,
                label: item.descripcion,
            }));

            setTipos(formattedData);
            setTiposFiltrados(formattedData);
        };
        fetchTiposTarjeta().then(() => {
            setTiposLoading(false);
            if (emisionValues?.tipoTarjeta) {
                setTipoSelected(emisionValues.tipoTarjeta)
            }
        });
    }, [])

    const onSubmit: SubmitHandler<IDatosTarjeta> = async (values: IDatosTarjeta) => {
        setEnviando(true);
        const { numeroTarjeta, titularTarjeta, vencimiento } = values
        setEmisionValues({
            ...emisionValues,
            numeroTarjeta: numeroTarjeta,
            titularTarjeta: titularTarjeta,
            banco: bancoSelected,
            tipoTarjeta: tipoSelected,
            vencimientoTarjeta: vencimiento,
        })

        const fechaNac = emisionValues.fechaNac ? `${emisionValues.fechaNac.dia}/${emisionValues.fechaNac.mes}/${emisionValues.fechaNac.anio}` : "";
        const fechaNacBeneficiario = emisionValues.accidentesPersonales?.beneficiario ? `${emisionValues.accidentesPersonales.beneficiario.fechaNac.dia}/${emisionValues.accidentesPersonales.beneficiario.fechaNac.mes}/${emisionValues.accidentesPersonales.beneficiario.fechaNac.anio}` : "";


        const fechaNacAsegurado = emisionValues.accidentesPersonales?.asegurados && emisionValues.accidentesPersonales?.asegurados[0] ? `${emisionValues.accidentesPersonales.asegurados[0].fechaNac.dia}/${emisionValues.accidentesPersonales.asegurados[0].fechaNac.mes}/${emisionValues.accidentesPersonales.asegurados[0].fechaNac.anio}` : "";


        const params: DataEmisionAP = {
            IdCotizacion: emisionValues.cotizacionDescAP.id + "" || "",
            DomicilioCalle: emisionValues.calle || "",
            DomicilioNumero: emisionValues.altura || "",
            DomicilioPiso: emisionValues.piso || "",
            DomicilioDepto: emisionValues.departamento || "",
            ClausulaNoRepeticion: false,
            MedioPago: "TarjetaCredito", //TODO: Preguntar a Pablo
            NumeroTarjeta: numeroTarjeta,
            Banco: bancoSelected?.value || "",
            TipoTarjetaCredito: tipoSelected?.value || "",
            NombreTitularTarjeta: titularTarjeta || "",
            ApellidoTitularTarjeta: titularTarjeta || "",
            MesVencimientoTarjeta: vencimiento.mes,
            AnioVencimientoTarjeta: "20" + vencimiento.anio,
            TipoCuentaBancaria: "",
            CBU: "",
            FechaNacimiento: fechaNac,
            Empresas: [],
            Asegurados: []
        }

        if (emisionValues.accidentesPersonales?.asegurados) {
            emisionValues.accidentesPersonales?.asegurados.forEach((asegurado) => {
                params.Asegurados.push({
                    Nombre: asegurado.nombre,
                    Apellido: asegurado.apellido,
                    IdActividad: asegurado.profesion.value,
                    TipoDocumento: asegurado.tipoDoc,
                    NroDocumento: asegurado.numDoc,
                    EstadoCivil: "",
                    FechaNacimiento: `${asegurado.fechaNac.dia}/${asegurado.fechaNac.mes}/${asegurado.fechaNac.anio}`,
                    Beneficiarios: asegurado.beneficiario ? [
                        {
                            Nombre: asegurado.beneficiario.nombre,
                            Apellido: asegurado.beneficiario.apellido,
                            TipoDocumento: asegurado.beneficiario.tipoDoc,
                            NroDocumento: asegurado.beneficiario.numDoc,
                            FechaNacimiento: `${asegurado.beneficiario.fechaNac.dia}/${asegurado.beneficiario.fechaNac.mes}/${asegurado.beneficiario.fechaNac.anio}`,
                            PorcentajeParticipacion: 0
                        }
                    ] : []
                })
            })
        }

        const response = await emisionAP(params);

        if (response.data && response.data.api_status == 200) {
            setEmisionValues({
                ...emisionValues,
                idPoliza: response.data.api_data.Id
            })
            nav("/ap/emision/solicitudenviada");
        } else {
            //TODO: Mostrar mensaje de error
            setHayError(true)
            setEnviando(false);
        }
    }

    const handleCheckboxChange1 = () => {
        setIsChecked1(!isChecked1);
    };

    const handleCheckboxChange2 = () => {
        setIsChecked2(!isChecked2);
    };

    const handleNumeroTarjetaChange = (e: any) => {
        const numeroTarjeta = e.target.value.replace(/\D/g, ''); // Eliminar caracteres que no sean números
        setValue("numeroTarjeta", numeroTarjeta); // Actualizar el valor en React Hook Form
        trigger("numeroTarjeta"); // Activa la validación del número de tarjeta
        setNumeroTarjeta(numeroTarjeta);
    };

    const handleTitularChange = (e: any) => {
        setTitularTarjeta(e.target.value)
        setFocused("name")
    }
    const handleMesChange = (e: any) => {
        setMes(e.target.value)
        setFocused("expiry")
        if (getValues("vencimiento.mes") !== "") {
            trigger("vencimiento.anio");
        }
    }
    const handleAnioChange = (e: any) => {
        setAnio(e.target.value)
        setFocused("expiry")
    }

    useEffect(() => {
        emisionValues.numeroTarjeta ? setValue("numeroTarjeta", emisionValues.numeroTarjeta) : setValue("numeroTarjeta", "")
        emisionValues.numeroTarjeta && trigger("numeroTarjeta")
        emisionValues.numeroTarjeta ? setNumeroTarjeta(emisionValues.numeroTarjeta) : setNumeroTarjeta("")

        emisionValues.titularTarjeta ? setValue("titularTarjeta", emisionValues.titularTarjeta) : setValue("titularTarjeta", "")
        emisionValues.titularTarjeta && trigger("titularTarjeta")
        emisionValues.titularTarjeta ? setTitularTarjeta(emisionValues.titularTarjeta) : setTitularTarjeta("")

        emisionValues.banco ? setValue("banco", emisionValues.banco.value) : setValue("banco", "")
        emisionValues.banco && trigger("banco")

        emisionValues.tipoTarjeta ? setValue("tipo", emisionValues.tipoTarjeta.value) : setValue("tipo", "")
        emisionValues.tipoTarjeta && trigger("tipo")

        emisionValues.vencimientoTarjeta?.mes ? setValue("vencimiento.mes", emisionValues.vencimientoTarjeta?.mes) : setValue("vencimiento.mes", "")
        emisionValues.vencimientoTarjeta?.mes && trigger("vencimiento.mes")
        emisionValues.vencimientoTarjeta?.mes ? setMes(emisionValues.vencimientoTarjeta.mes) : setMes("")

        emisionValues.vencimientoTarjeta?.anio ? setValue("vencimiento.anio", emisionValues.vencimientoTarjeta?.anio) : setValue("vencimiento.anio", "")
        emisionValues.vencimientoTarjeta?.anio && trigger("vencimiento.anio")
        emisionValues.vencimientoTarjeta?.anio ? setAnio(emisionValues.vencimientoTarjeta.anio) : setAnio("")
    }, [])

    const renderModalTerminosYCondiciones = () => {
        return (
            <ModalTerminosYCondiciones showChildren={false}>
                <div className={`mt-4 ${window.innerWidth > 768 && "d-flex"} justify-content-between`}>
                    <div>
                        <div style={{ display: "flex", alignItems: "baseline" }}>
                            <input
                                className='checkbox-container'
                                type="checkbox"
                                checked={isChecked1}
                                onChange={handleCheckboxChange1}
                            />
                            <label className={`label-color ${window.innerWidth < 768 && "fs-15"}`}>Acepto los Términos y Condiciones</label>
                        </div>
                        <div style={{ display: "flex", alignItems: "baseline" }}>
                            <input
                                className='checkbox-container'
                                type="checkbox"
                                checked={isChecked2}
                                onChange={handleCheckboxChange2}
                            />
                            <label className={`label-color ${window.innerWidth < 768 && "fs-15 mb-3"}`}>Acepto recibir póliza electrónica</label>
                        </div>
                    </div>
                    <button type="button"
                        className="btn btn-primary fs-18"
                        style={{ minWidth: "172px", height: "42px" }}
                        data-bs-dismiss="modal" aria-label="Close"
                        disabled={(isChecked1 === true && isChecked2 === true) ? false : true}
                    >
                        Continuar
                    </button>
                </div>
            </ModalTerminosYCondiciones>
        )

    }

    const identificarTipoTarjeta = (numeroTarjeta: string): TipoTarjeta => {

        if (
            numeroTarjeta.startsWith('589562') ||
            numeroTarjeta.startsWith('402918') ||
            numeroTarjeta.startsWith('527572') ||
            numeroTarjeta.startsWith('377798')
        ) {
            return "TARJETA NARANJA"
        } else if (
            numeroTarjeta.startsWith('6042') ||
            numeroTarjeta.startsWith('589657') ||
            numeroTarjeta.startsWith("627170")
        ) {
            return "CABAL"
        } else if (numeroTarjeta.startsWith('4')) {
            return "VISA"
        } else if (['51', '52', '53', '54', '55'].includes(numeroTarjeta.substring(0, 2)) ||
            (parseInt(numeroTarjeta.substring(0, 6)) >= 222100 && parseInt(numeroTarjeta.substring(0, 6)) <= 272099)) {
            return "MASTERCARD";
        } else if (numeroTarjeta.startsWith('34') || numeroTarjeta.startsWith('37')) {
            return "AMERICAN EXPRESS";
        } else if (
            numeroTarjeta.startsWith('300') ||
            numeroTarjeta.startsWith('301') ||
            numeroTarjeta.startsWith('302') ||
            numeroTarjeta.startsWith('303') ||
            numeroTarjeta.startsWith('304') ||
            numeroTarjeta.startsWith('305') ||
            numeroTarjeta.startsWith('36') ||
            numeroTarjeta.startsWith('38')
        ) {
            return "DINERS";
        }
        else {
            return "DESCONOCIDO";
        }
    }

    useEffect(() => {
        //debugger
        const tipo: TipoTarjeta = identificarTipoTarjeta(numeroTarjeta);
        let filtrados = tipos;
        if (tipo !== "DESCONOCIDO") {
            filtrados = filtrados.filter(t => t.label.toUpperCase() == tipo.toUpperCase());
        }

        if (filtrados.length === 0) {
            filtrados = tipos;
        }
        if (filtrados.length === 1) {
            setTipoSelected(filtrados[0]);
        }
        setTiposFiltrados(filtrados);
    }, [numeroTarjeta])

    const getCardType = (number: string): CardType => {
        const patterns = {
            cabal: /^6[0-1]|589657|627170/,
        };

        for (const [type, pattern] of Object.entries(patterns)) {
            if (pattern.test(number)) {
                return type as CardType;
            }
        }

        return 'default';
    };

    //const cardType = getCardType(numeroTarjeta);
    return (
        <div>
            <div className="px-20 pb-40 pb-lg-60 maxw-1170p mx-auto">
                <div className="d-lg-none">
                    <StyledLink to="" data-bs-target="#offcanvas" data-bs-toggle="collapse" className='btn1-md d-block fs-15 maxw-md-475p mx-md-auto' >Ver detalle de cobertura</StyledLink>
                </div>
                <div className="d-none d-lg-block">
                    <SegCoberturaInfo emisionValues={emisionValues} tipo='ACCIDENTES PERSONALES' />
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <SegFormEmisionContainer title='Datos de la tarjeta'>
                        <div className='d-flex flex-wrap col-12  justify-content-center'>
                            <div className='col-md-7 col-12 d-flex flex-column gap-4'>
                                <div className='col-md-12 d-flex flex-wrap gap-4'>
                                    <div className='col-md-5 col-12'>
                                        <Controller
                                            name="numeroTarjeta"
                                            control={control}
                                            rules={{
                                                required: "Ingresa el número de tarjeta",
                                                pattern: {
                                                    value: /^\d{13,16}$/, // Validar exactamente 16 dígitos numéricos
                                                    message: "El número de tarjeta debe contener entre 13 y 16 dígitos.",
                                                },
                                            }}
                                            render={({ field, fieldState }) => (
                                                <SegInput
                                                    id='numeroTarjeta'
                                                    label="Número de tarjeta"
                                                    name="numeroTarjeta"
                                                    type="text"
                                                    width={100}
                                                    onChange={handleNumeroTarjetaChange}
                                                    value={field.value}
                                                    leyendaError={fieldState.error ? fieldState.error.message : ""}
                                                    borderColor={fieldState.error ? "var(--bs-form-invalid-border-color)" : ""}
                                                    focusBorderColor={fieldState.error ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className='col-md-5 col-12'>
                                        <Controller
                                            name="titularTarjeta"
                                            control={control}
                                            render={({ field, fieldState }) => (
                                                <SegInput label='Nombre y Apellido (como figura en la tarjeta)' name='titularTarjeta' type='text' width={100} labelWidth='max-content'
                                                    value={field.value}
                                                    onChange={(e) => {
                                                        handleTitularChange(e)
                                                        setValue("titularTarjeta", e.target.value); // Actualiza el valor en React Hook Form
                                                        trigger("titularTarjeta");
                                                    }} />
                                            )}
                                        />
                                    </div>
                                </div>
                                <div className='col-md-12 d-flex flex-wrap gap-4'>
                                    <div className='col-md-5 col-12'>
                                        <FormProvider {...methods}>
                                            <SegSelect
                                                openDefault={false}
                                                label='Banco'
                                                options={bancos}
                                                loading={bancosLoading}
                                                width={"100%"}
                                                name="banco"
                                                selected={bancoSelected}
                                                setSelected={setBancoSelected}
                                            />
                                        </FormProvider>
                                    </div>
                                    <div className='col-md-5 col-12'>
                                        <FormProvider {...methods}>
                                            <SegSelect
                                                openDefault={false}
                                                label='Tipo'
                                                options={tiposFiltrados}
                                                loading={tiposLoading}
                                                width={"100%"}
                                                name="tipo"
                                                selected={tipoSelected}
                                                setSelected={setTipoSelected}
                                                isClearable
                                            />
                                        </FormProvider>
                                    </div>
                                </div>
                                <div className='col-md-12 d-flex flex-wrap mt-3 gap-4'>
                                    <div className='gap-4' style={{ display: "flex" }}>
                                        <div className='col-md-5'>
                                            <div className=" d-flex justify-content-center align-items-start gap-3" >
                                                <div style={{ paddingTop: "3%" }}>
                                                    <label className='fw-bold'>Vencimiento</label>
                                                </div>
                                                <div className=''>
                                                    <Controller
                                                        name="vencimiento.mes"
                                                        control={control}
                                                        rules={{
                                                            validate: {
                                                                required: (value) => {
                                                                    if (!value) {
                                                                        setIngreseMes(true)
                                                                        setErrorMes(false)
                                                                        setIngreseAnio(false)
                                                                    }
                                                                    else {
                                                                        setIngreseMes(false)
                                                                        setIngreseAnio(false)
                                                                        return true
                                                                    }
                                                                },
                                                                // onlyNumber: (value) => {
                                                                //     if (isNaN(parseInt(value))) {
                                                                //         return "Solo números"
                                                                //     }
                                                                //     else {
                                                                //         return true
                                                                //     }
                                                                // },
                                                                pattern: (value) => {
                                                                    if (value.length > 2 || value.length === 1) {
                                                                        // return "Mes debe incluir 2 dígitos"
                                                                    } else {
                                                                        return true
                                                                    }
                                                                },
                                                                // /^([0-9]{2})+$/.test(value) ||
                                                                // "2 dígitos entre 01 y 12",
                                                                minMaxMonth: (value) => {
                                                                    if (parseInt(value) > 12 || parseInt(value) <= 0) {
                                                                        setErrorMes(true)
                                                                    }
                                                                    else {
                                                                        setErrorMes(false)
                                                                        return true
                                                                    }
                                                                },
                                                            },
                                                        }}
                                                        render={({ field, fieldState }) => (
                                                            <SegInput
                                                                label=""
                                                                name="mes"
                                                                type="number"
                                                                width={100}
                                                                placeHolder="MM"
                                                                maxLenghtDigits={2}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    if (value.length <= 2) {
                                                                        handleMesChange(e);
                                                                        field.onChange(e);
                                                                        setValue("vencimiento.mes", value); // Actualiza el valor en React Hook Form
                                                                        trigger("vencimiento.mes");
                                                                        if (value.length === 2 && anioRef.current) {
                                                                            anioRef.current?.focus();
                                                                        }
                                                                    }
                                                                }}
                                                                value={field.value}
                                                                autoFocus={true}
                                                                // leyendaError={fieldState?.error?.message}
                                                                borderColor={`${formState.errors.vencimiento?.mes || errorVencimiento || errorMes || ingreseMes
                                                                    ? "var(--bs-form-invalid-border-color)"
                                                                    : ""
                                                                    }`}
                                                                focusBorderColor={`${formState.errors.vencimiento?.mes || errorVencimiento || errorMes || ingreseMes
                                                                    ? "var(--bs-form-invalid-border-color)"
                                                                    : "#2c7dfd"
                                                                    }`}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                <div>
                                                    <Controller
                                                        name="vencimiento.anio"
                                                        control={control}
                                                        rules={{
                                                            validate: {
                                                                required: (value) => {
                                                                    if (!value) {
                                                                        setIngreseAnio(true)
                                                                        setErrorAnio(false)
                                                                        setErrorVencimiento(false)
                                                                    }
                                                                    else {
                                                                        setIngreseAnio(false)
                                                                        return true
                                                                    }
                                                                },
                                                                pattern: (value) => {
                                                                    if (value.length > 2) {
                                                                        return "Año debe incluir 2 dígitos"
                                                                    } else {
                                                                        return true;
                                                                    }
                                                                },
                                                                minMonthAndYear: (value) => {
                                                                    const currentDate = new Date();
                                                                    const currentYear = currentDate.getFullYear().toString().slice(-2);
                                                                    const currentMonth = currentDate.getMonth() + 1; // Los meses en JavaScript se indexan desde 0 (enero es 0), por eso se suma 1.
                                                                    const enteredYear = parseInt(value);
                                                                    // Si el año ingresado es menor que el año actual, no pasa la validación.
                                                                    if (enteredYear < parseInt(currentYear)) {
                                                                        setErrorAnio(true);
                                                                    }
                                                                    else if (enteredYear > parseInt(currentYear)) {
                                                                        setErrorAnio(false)
                                                                    }
                                                                    // Si el año es igual al actual, comprobamos el mes.
                                                                    else if (enteredYear === parseInt(currentYear)) {
                                                                        setErrorAnio(false)
                                                                        const enteredMonth = parseInt(getValues("vencimiento.mes"));
                                                                        // Si el mes ingresado es menor o igual al mes actual, no pasa la validación.
                                                                        if (enteredMonth < currentMonth) {
                                                                            setErrorVencimiento(true);
                                                                        } else {
                                                                            setErrorVencimiento(false);
                                                                        }
                                                                    }
                                                                    // Si el año es mayor que el actual, siempre pasa la validación.
                                                                    return true;
                                                                },
                                                            },
                                                        }}
                                                        render={({ field, fieldState }) => (
                                                            <SegInput
                                                                ref={anioRef}
                                                                label=""
                                                                name="anio"
                                                                type="number"
                                                                width={100}
                                                                placeHolder="AA"
                                                                maxLenghtDigits={2}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    if (value.length <= 2) {
                                                                        handleAnioChange(e)
                                                                        field.onChange(e);
                                                                        setValue("vencimiento.anio", e.target.value); // Actualiza el valor en React Hook Form
                                                                        trigger("vencimiento.anio");
                                                                    }
                                                                }}
                                                                value={field.value}
                                                                autoFocus={true}
                                                                // leyendaError={fieldState?.error?.message}
                                                                borderColor={`${formState.errors.vencimiento?.anio || errorVencimiento || errorAnio || ingreseAnio
                                                                    ? "var(--bs-form-invalid-border-color)"
                                                                    : ""
                                                                    }`}
                                                                focusBorderColor={`${formState.errors.vencimiento?.anio || errorVencimiento || errorAnio || ingreseAnio
                                                                    ? "var(--bs-form-invalid-border-color)"
                                                                    : "#2c7dfd"
                                                                    }`}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <div style={{ color: "var(--bs-form-invalid-border-color)", position: "relative", marginTop: '1rem' }}>
                                                {(ingreseMes && !formState.errors.vencimiento?.mes && "Ingresá mes") || (errorMes && !formState.errors.vencimiento?.mes && "Mes del 1 al 12") || (ingreseAnio && !formState.errors.vencimiento?.anio && "Ingresá año") || (errorVencimiento && !formState.errors.vencimiento?.mes && !formState.errors.vencimiento?.anio && "Mes/Año de Vencimiento debe ser mayor o igual al Mes/Año actual") || (errorAnio && !formState.errors.vencimiento?.anio && "El año debe ser mayor o igual al actual") || formState.errors.vencimiento?.mes?.message || formState.errors.vencimiento?.anio?.message}
                                            </div>
                                            <div className="col-md-6" style={{ width: "auto", display: "inline-flex" }}>
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <div className="me-2 mb-0 mt-2">
                                                        <svg className="icon" width="23" height="29"><use xlinkHref="#lock"></use></svg>
                                                    </div>
                                                    <div className="mt-3 fs-9 lh-sm text-left">
                                                        La información que envíes mediante el sitio es privada y está resguardada por nuestros protocolos de seguridad.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {window.innerWidth >= 768 &&
                                            <div className='col-md-6'>
                                                <div style={{ display: "flex", alignItems: "baseline" }}>
                                                    <input
                                                        className='checkbox-container'
                                                        type="checkbox"
                                                        checked={isChecked1}
                                                        onChange={handleCheckboxChange1}
                                                    />
                                                    {renderModalTerminosYCondiciones()}
                                                </div>
                                                <div style={{ display: "flex", alignItems: "baseline" }}>
                                                    <input
                                                        className='checkbox-container'
                                                        type="checkbox"
                                                        checked={isChecked2}
                                                        onChange={handleCheckboxChange2}
                                                    />
                                                    <label className="">Acepto recibir póliza electrónica</label>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className='col-md-12 d-flex flex-wrap'>
                                    <div className='col-md-5'>
                                    </div>
                                </div>
                            </div>
                            <div className={`col-md-5 col-12 ${(window.innerWidth > 768) && "d-flex flex-column justify-content-evenly"}`}>
                                <StyledCardWrapper cardType={getCardType(numeroTarjeta)} className='d-flex justify-content-center'>
                                    <Cards
                                        number={numeroTarjeta}
                                        expiry={(mes) + (anio)}
                                        cvc={""}
                                        name={titularTarjeta}
                                        focused={focused}
                                        placeholders={{ name: "Nombre y Apellido" }}
                                        locale={{ valid: "valido hasta" }}
                                    />
                                </StyledCardWrapper>
                                {(window.innerWidth > 768) &&
                                    <>
                                        <div className="d-flex flex-column justify-content-center align-items-center">

                                            {
                                                hayError &&
                                                <div style={{ marginTop: "12px", fontSize: "14px" }}
                                                    className={`alert alert-danger w-75`}
                                                    role="alert">
                                                    Se ha producido un error de inesperado. Verificá que todo esté correcto e intentá nuevamente.
                                                </div>
                                            }

                                            <SegButton
                                                label={enviando ? "" : 'Contratar'}
                                                type='submit'
                                                disabled={numeroTarjeta !== "" && titularTarjeta !== "" && bancoSelected?.value !== undefined && tipoSelected?.value !== undefined && mes !== "" && anio !== ""
                                                    && !formState.errors.vencimiento?.mes && !formState.errors.vencimiento?.anio && errorVencimiento === false && isChecked1 === true && isChecked2 === true ? false : true}
                                                style={{ width: "290px", height: "42px" }}
                                                spinnerSize='small'
                                                className='fs-18'
                                                loading={enviando ? true : false}
                                            />



                                            <div className="text-center" style={{ paddingTop: "5px" }}>
                                                <a href={encodeURI("https://wa.me/5491169568002?text=Hola, necesito ayuda con la emisión de mi seguro " + (emisionValues?.cotizacionDesc?.planName! || null) + " de la aseguradora " + (emisionValues?.cotizacionDesc?.companyName! || null) + ". Quiero hablar con un asesor.")} target='_blank' rel='noreferrer' className="fs-14 fw-medium fs-md-17 a-dark">
                                                    <span className="hover-border-underline">Continuar por WhatsApp</span>
                                                    <svg className="icon" style={{ width: 20, height: 20, marginLeft: 5, verticalAlign: "middle" }}><use xlinkHref="#whatsapp"></use></svg>
                                                </a>
                                            </div>
                                        </div>

                                    </>
                                }
                            </div>
                        </div>
                        <div className={`d-flex mt-5 ${window.innerWidth < 768 ? 'justify-content-center' : 'justify-content-end align-items-end'}`} style={window.innerWidth < 768 ? { flexDirection: "column" } : {}}>
                            {window.innerWidth < 768 &&
                                <>
                                    <div>
                                        <div style={{ display: "flex", alignItems: "baseline" }}>
                                            <input
                                                className='checkbox-container'
                                                type="checkbox"
                                                checked={isChecked1}
                                                onChange={handleCheckboxChange1}
                                            />
                                            {renderModalTerminosYCondiciones()}
                                        </div>
                                        <div>
                                            <input
                                                className='checkbox-container'
                                                type="checkbox"
                                                checked={isChecked2}
                                                onChange={handleCheckboxChange2}
                                            />
                                            <label className="label-color">Acepto recibir póliza electrónica</label>
                                        </div>
                                    </div>
                                    <div className={`d-flex`}>
                                        <div style={{ width: "100%" }}>
                                            {
                                                hayError &&
                                                <div style={{ marginTop: "12px", fontSize: "14px" }}
                                                    className={`alert alert-danger w-100`}
                                                    role="alert">
                                                    Se ha producido un error inesperado. Verificá que todo esté correcto e intentá nuevamente.
                                                </div>
                                            }
                                            <SegButton
                                                label={enviando ? "" : 'Contratar'}
                                                type='submit'
                                                disabled={numeroTarjeta !== "" && titularTarjeta !== "" && bancoSelected?.value !== undefined && tipoSelected?.value !== undefined && mes !== "" && anio !== ""
                                                    && !formState.errors.vencimiento?.mes && !formState.errors.vencimiento?.anio && errorVencimiento === false && isChecked1 === true && isChecked2 === true ? false : true}
                                                loading={enviando ? true : false} lineHeight={enviando ? "100%" : ''}
                                                style={{ width: "100%", height: "42px" }}
                                                spinnerSize='small'
                                                className='fs-18'
                                            />
                                            <div className="text-center" style={{ paddingTop: "5px" }}>
                                                <a href={encodeURI("https://wa.me/5491169568002?text=Hola, necesito ayuda con la emisión de mi seguro " + (emisionValues?.cotizacionDesc?.planName! || null) + " de la aseguradora " + (emisionValues?.cotizacionDesc?.companyName! || null) + ". Quiero hablar con un asesor.")} target='_blank' rel='noreferrer' className="fs-14 fw-medium fs-md-17 a-dark">

                                                    <span className="hover-border-underline">Continuar por WhatsApp</span>
                                                    <svg className="icon" style={{ width: 20, height: 20, marginLeft: 5, verticalAlign: "middle" }}><use xlinkHref="#whatsapp"></use></svg>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </SegFormEmisionContainer>
                </form>

            </div>
            <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
                <symbol id="whatsapp" viewBox="0 0 24 24">
                    <path d="M6.9 20.6C8.4 21.5 10.2 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 13.8 2.5 15.5 3.3 17L2.44 20.306C2.39563 20.4767 2.39718 20.656 2.4445 20.8259C2.49181 20.9958 2.58321 21.1501 2.70941 21.2733C2.83562 21.3965 2.99215 21.4841 3.16313 21.5272C3.33411 21.5704 3.51347 21.5675 3.683 21.519L6.9 20.6Z" fill="#2D8D4D"></path>
                    <path d="M16.5 14.848C16.5 15.01 16.464 15.177 16.387 15.339C16.3084 15.5064 16.2053 15.6611 16.081 15.798C15.86 16.041 15.617 16.216 15.341 16.329C15.071 16.442 14.778 16.5 14.463 16.5C14.003 16.5 13.512 16.392 12.993 16.172C12.4443 15.9341 11.9243 15.6349 11.443 15.28C10.9195 14.8976 10.4254 14.4764 9.965 14.02C9.50946 13.5621 9.08926 13.0704 8.708 12.549C8.35762 12.0719 8.06115 11.5574 7.824 11.015C7.608 10.5 7.5 10.01 7.5 9.543C7.5 9.237 7.554 8.945 7.662 8.675C7.77 8.4 7.942 8.148 8.181 7.923C8.469 7.639 8.784 7.5 9.118 7.5C9.244 7.5 9.37 7.527 9.483 7.581C9.6 7.635 9.703 7.716 9.785 7.833L10.831 9.305C10.911 9.417 10.971 9.521 11.011 9.62C11.051 9.714 11.074 9.809 11.074 9.894C11.0727 10.0074 11.0398 10.1182 10.979 10.214C10.9096 10.3311 10.8248 10.4383 10.727 10.533L10.384 10.889C10.3601 10.9123 10.3414 10.9404 10.329 10.9714C10.3166 11.0024 10.3108 11.0356 10.312 11.069C10.312 11.104 10.317 11.136 10.326 11.172C10.339 11.208 10.353 11.235 10.362 11.262C10.442 11.411 10.582 11.604 10.781 11.838C10.984 12.072 11.2 12.311 11.434 12.549C11.678 12.788 11.912 13.008 12.151 13.211C12.385 13.408 12.579 13.543 12.732 13.624L12.814 13.661C12.8499 13.6738 12.8879 13.6799 12.926 13.679C12.9605 13.6797 12.9948 13.6733 13.0266 13.66C13.0585 13.6468 13.0872 13.627 13.111 13.602L13.453 13.264C13.566 13.152 13.674 13.067 13.778 13.012C13.8736 12.9511 13.9846 12.9185 14.098 12.918C14.1927 12.9194 14.2861 12.9394 14.373 12.977C14.472 13.017 14.576 13.075 14.688 13.152L16.18 14.21C16.2881 14.2803 16.3741 14.3798 16.428 14.497C16.4747 14.6082 16.4992 14.7274 16.5 14.848Z" fill="white"></path>
                </symbol>

                <symbol id="lock" viewBox="0 0 23 29" fill="none">
                    <path fill="#2C7DFD" fillRule="evenodd" clipRule="evenodd" d="M5.40788 9.67802C5.40898 9.9994 5.41009 10.3232 5.4101 10.6505C5.18616 10.6505 4.96633 10.6502 4.74923 10.65C4.323 10.6495 3.90728 10.649 3.49155 10.6505C1.47369 10.6573 0.00430809 12.1254 0.00205097 14.1478C-0.0013347 17.9308 -0.0013347 21.7149 0.00205097 25.4979C0.00430809 27.5215 1.47256 28.9964 3.48929 28.9964C8.83301 28.9998 14.1756 28.9987 19.5193 28.9941C19.7992 28.9941 20.0859 28.9715 20.3567 28.908C21.9401 28.5384 22.9908 27.1996 22.9942 25.5433C22.9981 23.5051 22.9971 21.4674 22.9961 19.4295C22.9957 18.5238 22.9953 17.618 22.9953 16.7121C22.9953 16.4478 22.9964 16.1835 22.9975 15.9192C23.0003 15.2585 23.003 14.598 22.9885 13.9381C22.9524 12.317 21.7347 10.9124 20.1355 10.7128C19.6252 10.6495 19.1069 10.652 18.5883 10.6544C18.3545 10.6555 18.1206 10.6565 17.8874 10.6516C17.8225 10.6501 17.7576 10.6506 17.6905 10.6511C17.656 10.6514 17.6209 10.6516 17.585 10.6516V6.10453C17.585 4.79289 17.2363 3.58555 16.4496 2.53239C14.5999 0.0564851 11.4264 -0.707598 8.67727 0.702668C6.94719 1.59032 5.84685 3.02212 5.52634 4.96407C5.423 5.59395 5.42092 6.24157 5.41884 6.88734C5.41824 7.07375 5.41765 7.26001 5.41461 7.44564C5.40275 8.18493 5.40529 8.92477 5.40788 9.67802ZM3.58861 12.9189H11.5054V12.9201H19.4223C20.3025 12.9201 20.7393 13.3565 20.7393 14.2374V25.4175C20.7393 26.2972 20.3014 26.7336 19.42 26.7336H3.58748C2.68802 26.7336 2.25578 26.3017 2.25578 25.4016V14.2487C2.25578 13.3497 2.68802 12.9189 3.58861 12.9189ZM15.3203 9.50204C15.3201 9.88 15.32 10.2593 15.32 10.6403H15.3188H7.68076C7.67901 10.615 7.67683 10.5897 7.67465 10.5645C7.6698 10.5082 7.66496 10.4521 7.66496 10.3965C7.66467 10.0357 7.66418 9.6749 7.66369 9.31407C7.66221 8.23175 7.66072 7.14944 7.66496 6.06712C7.67286 4.06962 9.10838 2.51085 11.1353 2.28865C13.0042 2.08459 14.7805 3.33955 15.2263 5.18514C15.2726 5.37672 15.3154 5.57511 15.3154 5.7701C15.3215 7.00878 15.3209 8.24813 15.3203 9.50204ZM10.3682 21.251C10.3691 21.2979 10.3701 21.3448 10.3701 21.3916H10.3713C10.3713 21.508 10.371 21.6243 10.3708 21.7406C10.3703 21.973 10.3698 22.2052 10.3713 22.4379C10.3758 23.1612 10.8306 23.6646 11.4829 23.6736C12.1442 23.6816 12.6227 23.1691 12.6261 22.4391C12.6295 21.7317 12.6318 21.0254 12.6239 20.318C12.6216 20.1446 12.6656 20.0312 12.8089 19.9156C13.7174 19.1832 13.8404 17.8716 13.0978 16.9658C12.3586 16.0657 11.0642 15.95 10.158 16.7039C9.28107 17.434 9.12307 18.7898 9.92435 19.6219C10.3205 20.0346 10.4119 20.4336 10.3724 20.9392C10.3638 21.0425 10.366 21.1467 10.3682 21.251Z"></path>
                </symbol>

            </svg>
        </div>
    )
}
